import React, { Fragment } from "react";

import Divider from "antd/es/divider";
import Popover from "antd/es/popover";
import cn from "classnames";

import { Activity } from "@mapmycustomers/shared/types/entity";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import ActivityTypeIcon from "@app/component/activity/ActivityTypeIcon";

import ActivityItem from "./ActivityItem";
import styles from "./ChartItem.module.scss";

const MAX_ROWS = 5;

interface Props {
  activities: Activity[];
  activityType: ActivityType;
  className?: string;
  rowIndex: number;
}

const ChartItem: React.FC<Props> = ({ activities, activityType, className, rowIndex }) => {
  return (
    <div className={cn(styles.container, styles[`row${rowIndex % MAX_ROWS}`], className)}>
      {activities.length > 0 && (
        <Popover
          content={
            <section className={styles.activityList}>
              {activities.map((activity, index) => (
                <Fragment key={activity.id}>
                  {index > 0 ? <Divider /> : null}
                  <ActivityItem activity={activity} />
                </Fragment>
              ))}
            </section>
          }
        >
          <span>
            <ActivityTypeIcon activityType={activityType} size="sm" tooltipProps={false} />
          </span>
        </Popover>
      )}
    </div>
  );
};

export default ChartItem;
